import { ErrorModel, ScreenInfo } from "../common"
import { NotificationMessageItem } from "../components/Notification"
import { MenuItem, SiteModule } from "../components/Menu"
import { SiteInfo } from "../app/appIndex"
import { UserInfo } from "../pages/login"
import { RouteInfo } from "../route"

/**
 * app环境
 * @param WeChat 微信环境
 * @param WorkWeChat 企业微信环境
 * @param DingTalk 钉钉
 * @param None 普通环境
 */
enum AppEnv {
    /**
     * 微信环境
     */
    WeChat,
    /**
     * 企业微信环境
     */
    WorkWeChat,
    /**
     * 钉钉
     */
    DingTalk,
    /**
     * 普通环境
     */
    None
}

type StoreState = {
    isPhone: boolean,
    displayName: string,
    externalState: boolean,
    appInitState: boolean,


    isLogin: boolean,
    userInfo: UserInfo,

    baseUrl: string,
    requestVerificationToken: string,

    siteInfo: SiteInfo,
    noticeCounter: number,
    noticeNeedConfirm: boolean,
    
    appState: number,
    thirdPartyLogin: boolean,
    warnMessages: Array<ErrorModel>,
    errorMessages: Array<ErrorModel>,
    routeInfo: RouteInfo,
    routePath: string,
    isWeChatEnv: boolean,
    appEnv: AppEnv,
    screenInfo: ScreenInfo,
    supportCamera: boolean,
    currentModule: string,
    modules: Array<SiteModule>,
    menuExpandState: boolean,
    menuItems: Object,
    flatMenuItems: Array<MenuItem>,
    hasInitMenu: boolean,

    
    notificationMessage: NotificationMessageItem,
    asyncNotificationCounter: number

    logOutEventCounter: number,
    humanLogOut: boolean,
    cacheTab: string,
    noCacheTab: string
} 

export {
    AppEnv,
    StoreState
}